// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"EditPane_inputGroup__7_Nef","requiredStyling":"EditPane_requiredStyling__QZ9VN","characterCounter":"EditPane_characterCounter__HBZeU"};